import { Theme } from '@mui/material';


const Progress = (theme: Theme) => {
  return {
    MuiLinearProgress: {
      variants: [
        {
          props: { color: 'primary' },
          style: {
            backgroundColor: '#eeeff2',
            borderRadius: 20,
          },
        },
      ],
    },
  };
};

export default Progress;
